import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import weekday from 'dayjs/plugin/weekday'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/nl'
import updateLocale from 'dayjs/plugin/updateLocale'
/* eslint-disable no-underscore-dangle -- the __dhlConfig variable is named this way */
import type { AppConfiguration } from '~/common/config/AppConfiguration'
import { getEnv } from '~/getEnv'

dayjs.locale('nl')
dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.extend(weekday)
dayjs.extend(isBetween)
dayjs.extend(updateLocale)

dayjs.updateLocale('nl', {
  weekStart: 0,
})

type ConfigVars = AppConfiguration & {
  CSP_NONCE: string
  VERSION: string
}

declare global {
  interface Window {
    __dhlConfig: ConfigVars
  }
}

// TODO: Unable to import devConfig from '../configuration/local.json'
// Causing vite/jest path resolve errors
// Workaround for now: Put (unit)test, e2e and dev configs here in stead of in the configuration folder
export const getConfig = () => {
  const env = getEnv()
  let config: ConfigVars
  if (env === 'test' || env === 'e2e') {
    config = {
      API_GATEWAY_HOST: 'http://localhost/api_gateway',
      BASE_PATH: '/',
      USER_API: 'http://localhost/user_api',
      AUTH_URL: 'http://localhost/auth',
      AUTH_REALM: 'mdp-admin',
      AUTH_CLIENT: 'mdp-admin',
      CSP_NONCE: 'nonce',
      VERSION: 'latest',
      RECEIVER_PRISMIC_ENDPOINT: 'https://receiverapp.cdn.prismic.io/api/v2',
      DISABLE_CCC_ORG_CRUD: 'true',
    }
  } else if (env === 'dev') {
    // local development with accept backend proxy
    config = {
      API_GATEWAY_HOST: 'https://api-gw-accept.dhlparcel.nl',
      BASE_PATH: '/',
      USER_API: 'https://sso-user-api-accept.dhlparcel.nl/api',
      AUTH_URL: 'https://sso-accept.dhlparcel.nl/auth',
      AUTH_REALM: 'internal',
      AUTH_CLIENT: 'mdp-admin',
      CSP_NONCE: 'nonce',
      VERSION: 'latest',
      RECEIVER_PRISMIC_ENDPOINT: 'https://receiverapp.cdn.prismic.io/api/v2',
      DISABLE_CCC_ORG_CRUD: 'true',
    }
  } else {
    // During accept and prod deploys, the config from the configuration folder is injected into the window object on index.html
    config = window.__dhlConfig
  }

  // Set the keycloak base path in the global scope so it can be consumed by useMutator of the keycloak-user-api package
  ;(window as unknown as any).dhlKeycloakUserApiBasePath = config.USER_API

  return {
    apiGatewayHost: config.API_GATEWAY_HOST,
    basePath: config.BASE_PATH,
    userApi: config.USER_API,
    authUrl: config.AUTH_URL,
    authRealm: config.AUTH_REALM,
    authClient: config.AUTH_CLIENT,
    version: config.VERSION,
    cspNonce: config.CSP_NONCE,
    receiverPrismicEndpoint: config.RECEIVER_PRISMIC_ENDPOINT,
    disableCccOrgCrud: config.DISABLE_CCC_ORG_CRUD === 'true',
  }
}

export const MuiProLicenseKey =
  '4e69653ab0c9c03be22aeac2727864aeTz0xMzAzNDksRT0xODEzNDQ5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9NCxLVj0y'

export const config = getConfig()
